import { IconStar } from '@tabler/icons-react';
import { PromptFeedbackTooltip } from 'components/Modal/PromptFeedbackTooltip';
import { ModalHeaderActionButton } from 'components/Modal/styles';
import { useAppDispatch, useAppSelector } from 'hooks';
import { selectLegibleTextColor } from 'reducers/config';
import { selectCsatUiState, setCsatStatesByKey } from 'reducers/workflows';

interface CsatButtonProps {
  color?: string;
  size?: number;
}

export const CsatButton = ({ color, size = 20 }: CsatButtonProps) => {
  const dispatch = useAppDispatch();
  const csatUiState = useAppSelector(selectCsatUiState);
  const legibleElementColor = useAppSelector(selectLegibleTextColor);
  const iconColor = color || legibleElementColor;

  const handleCsatClicked = () => {
    csatUiState.visible
      ? dispatch(setCsatStatesByKey({ isCsatVisible: false }))
      : dispatch(
          setCsatStatesByKey({
            isCsatVisible: true,
            triggeredFrom: 'header-button-clicked',
          }),
        );
  };

  return (
    <PromptFeedbackTooltip tooltipContent='Give us feedback anytime'>
      <ModalHeaderActionButton
        aria-label='Feedback'
        disabled={csatUiState.disabled}
        onClick={handleCsatClicked}
        selected={csatUiState.visible}
      >
        <IconStar color={iconColor} size={size} />
      </ModalHeaderActionButton>
    </PromptFeedbackTooltip>
  );
};
